<script type="text/ecmascript-6">
    export default {
        props: ['pageditems', 'filter', 'dataurl', 'loading'],

        computed: {
            activeFilters: function() {
                return _.pickBy(this.filter, function(value, key) {
                    if (key == 'page') {
                        return value != 1;
                    }
                    return value != null;
                })
            }
        },

        methods: {
            fetchItems: function (page) {
                this.$emit('changing-page', page);
                Vue.set(this.filter, 'page', page);

                this.$nextTick(() => {
                  window.location.href = this.dataurl+'?' + $.param( this.activeFilters ? this.activeFilters : this.filter );
                });
            }
        }
    }
</script>

<template>
    <div class="table-pager">
        <pagination
            :data="pageditems"
            :limit="5"
            :show-disabled="false"
            @pagination-change-page="fetchItems"
        >
            <span slot="prev-nav">« {{ __('scoop-os.common.previous') }}</span>
            <span slot="next-nav">{{ __('scoop-os.common.next') }} »</span>
        </pagination>
    </div>
</template>

<style>

</style>
